/** @format */

import React, { useState } from "react";

//material ui
import {
  Typography,
  Menu,
  MenuItem,
  useMediaQuery,
  ListItemButton,
} from "@mui/material";
import { useTheme } from "@mui/styles";

//icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

//translation
import { useTranslation } from "react-i18next";

const LanguageMenu = () => {
  const isMobile = useMediaQuery("(max-width:1005px)");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();

  const { i18n } = useTranslation();

  const initialLenguage = () => {
    if (localStorage.getItem("lang") === null) {
      localStorage.setItem("lang", "es")
    }
    return localStorage.getItem("lang")
  }

  const [selectedLanguage, setSelectedLanguage] = useState(initialLenguage);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang) => {
    setAnchorEl(null);
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang)
    setSelectedLanguage(lang);
    window.location.reload();
  };

  return isMobile ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
      }}
    >
      <ListItemButton>
        <Typography
          onClick={() => handleClose("es")}
          textalign="center"
          style={{ margin: "1rem" }}
        >
          <span role="img" aria-label="Argentina Flag">
            🇦🇷
          </span>
        </Typography>
        <Typography
          onClick={() => handleClose("en")}
          textalign="center"
          style={{ margin: "1rem" }}
        >
          <span role="img" aria-label="World">
            🌎
          </span>
        </Typography>
      </ListItemButton>
    </div>
  ) : (
    <>
      <Typography
        aria-controls={open ? "basic-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          "&:hover": {
            bgcolor: theme.palette.white.secondary,
          },
          display: "flex",
        }}
      >
        {selectedLanguage === "es" ? "🇦🇷" : "🌎"}
        <KeyboardArrowDownIcon sx={{ color: theme.palette.blue.main }} />
      </Typography>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handleClose("es")}>
          <span role="img" aria-label="Argentina Flag">
            🇦🇷
          </span>
        </MenuItem>
        <MenuItem onClick={() => handleClose("en")}>
          <span role="img" aria-label="World">
            🌎
          </span>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageMenu;
